import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import Loader from '../../../../_common/Loader/Loader';
import classes from './tabs.module.scss';
import Pagination from '../../../../_common/Pagination/Pagination';
import { getPhysicianGroupUsersRequest, getPhysicianUsersRequest } from '../../../../../store/actions/physicians';
import AccountHelpers from '../../../../../utils/accountHelpers';
import Button from '../../../../_common/Form/Buttons/Button';
import Api from '../../../../../api/api';
import { getAccountRequest } from '../../../../../store/actions/auth';

const initTableHeader = (type, addLoginBtn) => {
  const header = [
    {
      name: 'Name',
      path: 'name',
    },
    {
      name: type === 'group' ? 'UserName' : 'Phone',
      path: type === 'group' ? 'username' : 'phone',
    },
    {
      name: 'Email',
      path: 'email',
    },
  ];

  if (addLoginBtn) header.push({ name: 'Login', path: 'login' });

  return header;
};

const Users = ({ type }) => {
  const dispatch = useDispatch();
  const {
    physicianUsers, physicianUsersTotalPage, requestStatus,
    physicianGroupUsers,
  } = useSelector((store) => store.physicians);

  const { physicianId, groupName, healthId } = useParams();

  const navigate = useNavigate();
  const [loginLoad, setLoginLoad] = useState(false);

  const initialData = useCallback(() => {
    const data = {
      limit: 15,
      page: 1,
    };

    if (type === 'health') {
      data.role = 'Health';
      data.groupId = healthId;
    } else {
      data.role = 'Physician';
      data.groupName = physicianId;
    }

    return data;
  }, []);

  const [requestData, setRequestData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  const { limit, page } = requestData;

  const [tableHeader, setTableHeader] = useState([]);

  useEffect(() => {
    setTableHeader(initTableHeader(type, (!type || type === 'health') && AccountHelpers.getUser().role === 'Admin'));
  }, []);

  useEffect(() => {
    if (type === 'group') {
      dispatch(getPhysicianGroupUsersRequest({ group: groupName }));
    } else {
      dispatch(getPhysicianUsersRequest(requestData));
    }
  }, []);

  const onChangePageData = async (path, count) => {
    setLoading(true);

    const newRequestData = { ...requestData, [path]: count };

    if (path === 'limit') {
      newRequestData.page = 1;
    }
    if (type === 'group') {
      dispatch(getPhysicianGroupUsersRequest({ ...requestData, groupName }));
    } else {
      await dispatch(getPhysicianUsersRequest(newRequestData));
    }

    setRequestData(newRequestData);

    setLoading(false);
  };

  const healthLogin = async (e, id) => {
    e.stopPropagation();
    setLoginLoad(true);

    AccountHelpers.setAdminData();

    const { data } = await Api.loginAdminToHealth({ id });

    AccountHelpers.setToken(data.token);
    AccountHelpers.setRefreshToken(data.refreshToken);

    await dispatch(getAccountRequest(id));

    window.location.href = '/patients';
  };

  return (
    loginLoad ? createPortal(
      <div
        className={classes.loader_container}
      >
        <Loader />
      </div>,
      document.getElementById('root') || document.body,
    )
      : !loading && requestStatus === 'request'
        ? <Loader className={classes.loader} />
        : (requestStatus === 'success' && !physicianUsers.length && !physicianGroupUsers.length)

          ? <div className={classes.notResult}>No Data Found</div>
          : (
            <div style={{ width: '60%' }}>

              <div className={classes.table_wrapper}>

                { loading && <Loader />}

                <table>

                  <thead>
                    <tr>
                      {tableHeader.map((h) => (
                        <th key={h.name}>{h.name}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {type !== 'group'
                      ? physicianUsers.map((s) => (
                        <tr key={s.id} onClick={() => navigate(`/team/${s.id}/edit`)}>
                          {tableHeader.map((h) => (
                            h.path === 'login'
                              ? (
                                <td key={h.name} onClick={(e) => e.stopPropagation()}>
                                  <Button
                                    title="Login"
                                    className={classes.login_btn}
                                    type="button"
                                    reverseColor
                                    loading={loginLoad === s.id}
                                    onClick={(e) => healthLogin(e, s.id)}
                                  />
                                </td>
                              )
                              : h.path === 'name'
                                ? (
                                  <td key={h.name}>
                                    {s?.name}
                                  </td>
                                )
                                : <td key={h.name}>{_.get(s, h.path) || '-'}</td>
                          ))}

                        </tr>
                      ))
                      : physicianGroupUsers.map((s) => (
                        <tr key={s.id} onClick={() => navigate(`/team/${s.id}/edit`)}>
                          {tableHeader.map((h) => (
                            <td key={h.name}>{_.get(s, h.path) || '-'}</td>
                          ))}

                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {type !== 'group' && (
              <Pagination
                page={+page - 1}
                limit={limit}
                totalPage={+physicianUsersTotalPage}
                onChange={onChangePageData}
              />
              )}

            </div>
          )
  );
};

Users.propTypes = {
  type: PropTypes.string,
};

Users.defaultProps = {
  type: '',
};

export default Users;
